namespace RioERP.Masters {
    export interface TaxRateForm {
        TaxCategoryId: Serenity.LookupEditor;
        StateId: Serenity.LookupEditor;
        TaxTypeId: Serenity.LookupEditor;
        Rate: Serenity.DecimalEditor;
        FromDate: Serenity.DateEditor;
        ToDate: Serenity.DateEditor;
    }

    export class TaxRateForm extends Serenity.PrefixedContext {
        static formKey = 'Masters.TaxRate';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TaxRateForm.init)  {
                TaxRateForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.DecimalEditor;
                var w2 = s.DateEditor;

                Q.initFormType(TaxRateForm, [
                    'TaxCategoryId', w0,
                    'StateId', w0,
                    'TaxTypeId', w0,
                    'Rate', w1,
                    'FromDate', w2,
                    'ToDate', w2
                ]);
            }
        }
    }
}
